/* Maison Byōbu · les scènes de l'accueil et des pages œuvre, racontées par le défilement.
   Des sections hautes, un écran collant (position: sticky), une seule boucle d'animation qui lit
   la position des scènes visibles et n'écrit que transform et opacity. Aucune bibliothèque.
   Sans la classe mb-js (animations réduites), rien ne s'anime : les compositions fixes du CSS s'affichent. */
(() => {
  window.mbScenesPret = true;
  const d = document;
  if (!d.documentElement.classList.contains('mb-js')) return;

  const borne = (v, a = 0, b = 1) => Math.min(Math.max(v, a), b);
  const plage = (p, a, b) => borne((p - a) / (b - a));
  const lisse = (t) => t * t * (3 - 2 * t);
  const sortie = (t) => 1 - Math.pow(1 - t, 3);
  const mix = (a, b, t) => a + (b - a) * t;
  const bureau = () => innerWidth >= 990;
  const pointeurFin = matchMedia('(pointer: fine)').matches;

  /* Progression d'une scène collante : 0 quand elle arrive en haut, 1 quand elle repart */
  const progression = (r, vh) => { const course = r.height - vh; return course > 0 ? borne(-r.top / course) : borne(-r.top / r.height); };
  /* Interpolation entre des repères [p, ...valeurs] */
  const repere = (cles, p) => {
    if (p <= cles[0][0]) return cles[0].slice(1);
    for (let i = 1; i < cles.length; i++) {
      if (p <= cles[i][0]) {
        const t = lisse(plage(p, cles[i - 1][0], cles[i][0]));
        return cles[i].slice(1).map((v, k) => mix(cles[i - 1][k + 1], v, t));
      }
    }
    return cles[cles.length - 1].slice(1);
  };
  const montrer = (els, p) => els.forEach((el) => el.classList.toggle('mb-visible', p >= +el.dataset.de && p < +el.dataset.a));

  /* ---------- Accueil, « Imaginez-la chez vous » (02/10) : sur le mur nu, l'œuvre se déplie panneau par panneau
     pendant que la pièce traverse l'écran (les six panneaux du mur nu se replient l'un après l'autre) ---------- */
  function habillage(s) {
    const pans = [...s.querySelectorAll('.mb-habillage__nu > span')];
    return (r, vh) => {
      const p = progression(r, vh);
      pans.forEach((pan, i) => {
        const a = 0.12 + (5 - i) * 0.07;
        const t = sortie(plage(p, a, a + 0.38));
        pan.style.transform = `scaleX(${(1.01 * (1 - t)).toFixed(4)})`;
      });
    };
  }

  /* ---------- Page d'une œuvre (02/10, B2) : les lignes de la lecture se posent une à une et restent ---------- */
  function lecture(s) {
    const lignes = [...s.querySelectorAll('.mb-recit__ligne')];
    const n = lignes.length || 1;
    return (r, vh) => {
      const p = progression(r, vh);
      lignes.forEach((l, i) => {
        const a = 0.04 + i * (0.78 / n);
        const t = sortie(plage(p, a, a + 0.1));
        l.style.opacity = t.toFixed(3);
        l.style.transform = `translate3d(0, ${((1 - t) * 14).toFixed(1)}px, 0)`;
      });
    };
  }

  /* ---------- Page d'une œuvre (02/10, B3) : l'œuvre émerge du papier, puis on la parcourt si elle dépasse l'écran.
     Elle remplit la hauteur de l'écran ; plus étroite que l'écran, elle reste centrée, sans jamais glisser. ---------- */
  function revelation(s) {
    const colle = s.querySelector('.mb-scene__colle');
    const img = s.querySelector('.mb-recit__image');
    const ratio = parseFloat(getComputedStyle(s).getPropertyValue('--ratio')) || 1;
    return (r, vh) => {
      const p = progression(r, vh);
      const W = colle.clientWidth, H = colle.clientHeight, lw = H * ratio;
      const t = sortie(plage(p, 0, 0.22));
      const q = lisse(plage(p, 0.26, 0.96));
      const x = lw > W ? -(lw - W) * q : (W - lw) / 2;
      img.style.opacity = t.toFixed(3);
      img.style.transform = `translate3d(${x.toFixed(1)}px, 0, 0) scale(${(1.03 - 0.03 * t).toFixed(4)})`;
    };
  }

  /* ---------- Le héros (02/10) : la mise en situation s'agrandit depuis le haut, symétriquement,
     jusqu'à la pleine largeur ; jamais de déplacement de côté ni de recadrage (beau cadrage avant l'animation) ---------- */
  function heros(s) {
    const cadre = s.querySelector('.mb-heros__cadre');
    const legende = s.querySelector('.mb-heros__legende');
    const defileur = () => (bureau() && d.querySelector('.page-wrapper')) || d.scrollingElement;
    let kMax = 1;
    /* la place que prendra le cadre agrandi est réservée dessous : la section ne le coupe jamais */
    const mesurer = () => {
      cadre.style.transform = '';
      kMax = d.documentElement.clientWidth / cadre.offsetWidth;
      s.style.marginBottom = `${Math.max(0, (kMax - 1) * cadre.offsetHeight).toFixed(0)}px`;
    };
    mesurer();
    addEventListener('resize', mesurer);
    /* le petit logo de l'en-tête attend que le grand soit passé */
    const logo = d.querySelector('[data-mb-heros-logo]');
    if (logo && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => d.documentElement.classList.toggle('mb-heros-passe', !e.isIntersecting)).observe(logo);
    }
    return (r, vh) => {
      const y = defileur().scrollTop;
      const course = Math.max(r.top + y - vh * 0.1, 1);
      const t = lisse(borne(y / course));
      const k = 1 + (kMax - 1) * t;
      cadre.style.transform = `scale(${k.toFixed(4)})`;
      if (legende) legende.style.transform = `translate3d(0, ${((k - 1) * cadre.offsetHeight).toFixed(1)}px, 0)`;
    };
  }

  /* ---------- Page d'une œuvre (04/10) : le gros plan grandit doucement. La tuile ne bouge pas et reste visible ;
     l'image, à l'intérieur, passe de 1 à 1,08 pendant que la tuile traverse l'écran (de son entrée en bas à sa sortie en haut) ---------- */
  function grosPlan(s) {
    const img = s.querySelector('img');
    return (r, vh) => {
      const p = borne((vh - r.top) / (vh + r.height));
      img.style.transform = `scale(${(1 + 0.08 * p).toFixed(4)})`;
    };
  }

  /* les scènes de l'ancienne architecture de l'accueil sont archivées dans _brief/archives/accueil-avant-02-10 */
  const scenes = { heros, habillage, lecture, revelation, grosPlan };

  /* ---------- La boucle ---------- */
  const visibles = new Set();
  const liste = [];
  d.querySelectorAll('[data-mb-scene]').forEach((el) => {
    const f = scenes[el.dataset.mbScene];
    if (!f) return;
    try { liste.push({ el, maj: f(el) }); } catch (e) { console.warn('[mb-scenes]', el.dataset.mbScene, e); }
  });
  const io = new IntersectionObserver((entrees) => {
    for (const e of entrees) {
      const sc = liste.find((x) => x.el === e.target);
      if (!sc) continue;
      if (e.isIntersecting) visibles.add(sc); else visibles.delete(sc);
    }
    demander();
  }, { rootMargin: '25% 0px 25% 0px' });
  liste.forEach((x) => io.observe(x.el));

  let prevu = false;
  function demander() { if (!prevu) { prevu = true; requestAnimationFrame(boucle); } }
  function boucle() {
    prevu = false;
    const vh = innerHeight;
    for (const sc of visibles) sc.maj(sc.el.getBoundingClientRect(), vh);
  }
  /* Horizon fait défiler .page-wrapper sur ordinateur, la fenêtre sur mobile : on écoute toute la page */
  d.addEventListener('scroll', demander, { passive: true, capture: true });
  addEventListener('resize', demander);
  demander();
})();
